import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Dropdown, Modal, Button as ButtonBoot } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { Buildings, Desktop, Video, Cube } from '@phosphor-icons/react';
import {
  IPropsSearchOption,
  IPropsRankActive,
} from '../../../../jsx/components/Dashboard/@types/listActiveType';

import {
  List,
  MagnifyingGlass,
  Plugs,
  EyeSlash,
  Eye,
  ArrowLeft,
  PlugsConnected,
  WarningCircle,
  Crown,
  GearSix,
} from '@phosphor-icons/react';
import { Autocomplete } from '@mui/material';
import axios from 'axios';
import { Dropdown as DropdownAntd, Menu } from 'antd';
import { useNewTheme } from '../../../../hooks/useNewTheme';
import { HeaderMenu } from '../HeaderMenu';
import { LinkAccountB3 } from '../../../components/Dashboard/Settings/LinkAccountB3';
import { SwitchAutoImport } from '../../../../components/SwitchAutoImport';
import { useTitleAndUser } from '../../../../hooks/userTitle';
import { useActives } from '../../../../hooks/useActives';
import { Notifications } from './components/Notifications';
import {
  Container,
  ContentUser,
  ContainerShowMenu,
  ContainerOptionSearch,
} from './styles';
import { ModalDesigner } from '../../../../components/ModalDesigner';
import imageVoltar from '../../../../assets/Voltar.png';
import imageLogo from '../../../../assets/Logo icon.svg';
import userdefault from '../../../../assets/User.png';
import { userRoutes } from "../../../../utils/RoutesApi";
import { AppTour } from '../../../components/TourApp/AppTour';

export interface IPropsPlan {
  NomePlano: string;
  Status: string;
  StatusPagamentoCorrente: string;
  SubscriptionId: string;
  UserName: string;
  Valor: number;
  cardLastDigitsCard: number | null;
  card_brand: number | null;
  currentPeriodEnd: string;
  currentPeriodStart: string;
  manageUrl: string;
  paymentMethod: string;
}

const baseUrl = process.env.REACT_APP_API_URL;

interface IPropsHeader {
  shortSidebar: boolean;
}

export function Header({ shortSidebar }: IPropsHeader) {
  //@ts-ignore
  const { user, title, b3Connected } = useTitleAndUser();
  //@ts-ignore
  const { isMobile } = useNewTheme();
  //@ts-ignore
  const { showActive, setShowActive } = useActives();

  const history = useHistory();
  // Lista fixa das telas do sistema para o autocomplete
  const appScreens = [
    {
      label: 'Dashboard',
      path: '/dashboard',
      keywords: ['início', 'home', 'dashboard'],
    },
    {
      label: 'Carteira',
      path: '/wallet',
      keywords: ['carteira', 'patrimônio', 'investimentos'],
    },
    {
      label: 'Análise',
      path: '/analysis',
      keywords: [
        'ações',
        'fii',
        'análise',
        'analise',
        'tela de análise',
        'tela de analise',
      ],
    },
    {
      label: 'Renda passiva',
      path: '/renda-passiva',
      keywords: ['renda passiva', 'renda', 'passiva', 'dividendos', 'juros'],
    },
    {
      label: 'Simuladores',
      path: '/simuladores',
      keywords: ['simuladores', 'simulador', 'simulação', 'calculadora'],
    },
    {
      label: 'Imposto de renda',
      path: '/imposto-renda',
      keywords: [
        'ir',
        'irpf',
        'tributos',
        'imposto de renda',
        'imposto',
        'renda',
      ],
    },
    {
      label: 'Cursos iBox6 — Premium',
      path: '/cursos-premium',
      keywords: ['curso', 'cursos', 'premium', 'kit do investidor', 'aula'],
    },
    {
      label: 'Cursos iBox6 — Gratuitos',
      path: '/cursos-gratuitos',
      keywords: ['curso', 'cursos', 'aula'],
    },
    {
      label: 'Tutorial',
      path: '/tutoriais',
      keywords: ['tutorial', 'tutoriais', 'plataforma'],
    },
    {
      label: 'Educação',
      path: '/Educacao',
      keywords: [
        'aprendizado',
        'ensino',
        'educação',
        'educacao',
        'curso',
        'cursos',
        'aula',
      ],
    },
    {
      label: 'Comunidade',
      path: '/recommended-posts',
      keywords: ['forum', 'posts', 'social', 'fórum', 'comunidade', 'iboxer'],
    },
    {
      label: 'Seja Premium',
      path: '/pagamentos',
      keywords: [
        'assinatura',
        'plano',
        'upgrade',
        'planos',
        'assinaturas',
        'premium',
        'assinar',
      ],
    },
    {
      label: 'Configurações',
      path: '/profile-edit',
      keywords: ['ajustes', 'perfil', 'conta', 'configurar', 'mudar senha'],
    },
    {
      label: 'Suporte',
      path: 'https://api.whatsapp.com/send/?phone=5555997265220&text=Fale+conosco%21&type=phone_number&app_absent=0',
      keywords: ['ajuda', 'faq', 'atendimento', 'suporte', 'help'],
    },
    {
      label: 'Mundo GIF',
      path: 'https://app.mundogif.com.br/login',
      keywords: [
        'luciano',
        'mundo',
        'gif',
        'cursos',
        'investimentos',
        'mundo GIF',
        'mundo gif',
      ],
    },
  ];

  const [styledHeader, setStyledHeader] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [inputSearch, setInputSearch] = useState('');
  const [hasResult, setHasResult] = useState(false);
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState<IPropsPlan | null>(null);
  // Adicione esse tipo acima do componente
  type ISearchOption =
    | IPropsSearchOption
    | {
        type: 'screen';
        name: string;
        path: string;
        key: string;
      };

  // E troque o useState:
  const [searchOptions, setSearchOptions] = useState<ISearchOption[]>([]);

  const [modalLinkAccountB3, setModalLinkAccountB3] = useState(false);
  //@ts-ignore

  useEffect(() => {
    if (!isMobile) {
      setShowMenu(false);
    }
  }, [isMobile]);
  useEffect(() => {
    if (
      title === '' ||
      (location.pathname.match('user-posts') &&
        //@ts-ignore
        location.pathname.match('user-posts')[0] === 'user-posts')
    ) {
      setStyledHeader(false);
    } else {
      setStyledHeader(true);
    }
    function scrollPosition() {
      if (
        title === '' ||
        (location.pathname.match('user-posts') &&
          //@ts-ignore
          location.pathname.match('user-posts')[0] === 'user-posts')
      ) {
        window.scrollY > 250 ? setStyledHeader(true) : setStyledHeader(false);
      } else {
        window.scrollY > 80 && setStyledHeader(true);
      }
    }
    window.addEventListener('scroll', scrollPosition);
    return () => {
      window.removeEventListener('scroll', scrollPosition);
    };
  }, [title]);

  useEffect(() => {
    if (inputSearch.length > 0) {
      const timeOutId = setTimeout(() => {
        searchFunction(inputSearch);
      }, 500);
      return () => clearTimeout(timeOutId);
    } else {
      setSearchOptions([]);
      setHasResult(false);
    }
  }, [inputSearch]);

  const searchFunction = async (search: string) => {
    setLoadingSearch(true);
    setHasResult(true);

    // resultados locais (telas do app)
    const filteredScreens: IPropsSearchOption[] = appScreens
      .filter((screen) => {
        const searchLower = search.toLowerCase();
        return (
          screen.label.toLowerCase().includes(searchLower) ||
          screen.keywords?.some((keyword) =>
            keyword.toLowerCase().includes(searchLower)
          )
        );
      })
      .map((screen) => ({
        type: 'screen', // ✅ aqui forçamos o tipo correto
        name: screen.label,
        path: screen.path,
        key: `screen-${screen.label}`, // melhor usar algo único em vez de só "search"
      }));

    try {
      // dentro do searchFunction
      const response = await axios.get(
        `${baseUrl}/Finance/dashboard/search?search=${search}`
      );

      const newData: IPropsSearchOption[] = response.data.map((item: any) => {
        // base comum
        const base = {
          key: search,
          // legacy fields usados pelo seu renderOption:
          Assets: item.name, // o que seu código mostra como título
          NomeEmpresa: item.name, // usado em <strong>{option.Assets}</strong> – ajuste se tiver nome diferente
          LOGO_BRAND: item.image || undefined,
          path: undefined as string | undefined,
          SegmentoMercado: undefined as string | undefined,
        };

        if (item.type === 'acao') {
          return {
            ...base,
            type: 'acao',
            Assets: item.name,
            NomeEmpresa: item.name,
            SegmentoMercado: 'ACAO',
            LOGO_BRAND: item.image || undefined,
            name: item.name,
            image: item.image,
            id: item.id,
          };
        }

        if (item.type === 'fii') {
          return {
            ...base,
            type: 'fii',
            Assets: item.name,
            NomeEmpresa: item.name,
            SegmentoMercado: 'FII',
            LOGO_BRAND: item.image || undefined,
            name: item.name,
            image: item.image,
            id: item.id,
          };
        }

        if (item.type === 'video') {
          return {
            ...base,
            type: 'video',
            Assets: item.name,
            NomeEmpresa: '(Vídeo)',
            SegmentoMercado: 'VIDEO',
            name: item.name,
            image: item.image,
            id: item.id,
            video_id: item.video_id,
            path: `/watch/?v=${item.video_id}`, // navegação para vídeo
          };
        }

        // default fallback
        return {
          ...base,
          type: item.type || 'screen',
          name: item.name,
          image: item.image,
          id: item.id,
          video_id: item.video_id,
        };
      });

      const allResults = [...filteredScreens, ...newData];
      setSearchOptions(allResults);
    } catch (err) {
      console.error('Erro busca:', err);
      setHasResult(false);
      setSearchOptions([]);
    } finally {
      setLoadingSearch(false);
    }
  };

  const menu = (
    <Menu
      style={{ top: '10px' }}
      items={[
        {
          label: <SwitchAutoImport />,
          key: '0',
        },
      ]}
    />
  );
  function handleBackPage() {
    window.history.back();
  }
  const typeLabels: Record<string, string> = {
    fii: 'FII',
    acao: 'Ação',
    video: 'Vídeo',
  };

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}${userRoutes.STATUS_PAYMENT}`
        );
        setPlan(response.data);
      } catch (error) {
        setPlan(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPlan();
  }, []);

  const isPremium =
    (plan && ['premium'].includes(plan.NomePlano?.toLowerCase?.() || '')) ||
    (plan && plan?.currentPeriodEnd?.[0] === '3'); // handle infinite plan

  const renderSearchMenu = () => {
    return (
      <Autocomplete
        getOptionLabel={(option: ISearchOption) =>
          'Assets' in option
            ? option.Assets ?? option.NomeEmpresa ?? option.key
            : option.name
        }
        options={searchOptions}
        onInputChange={(e, value) => setInputSearch(value)}
        open={hasResult}
        loadingText={
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <ReactLoading type="balls" color="#495660" width={60} height={60} />
          </div>
        }
        fullWidth
        loading={loadingSearch}
        noOptionsText="Nenhum resultado encontrado"
        renderInput={(params) => (
          <div ref={params.InputProps.ref} className="searchContainer">
            <input
              type="text"
              {...params.inputProps}
              placeholder="Pesquise por um ativo"
              className="searchInput"
            />
            <MagnifyingGlass
              size={24}
              color="#F1F2F3"
              style={{ cursor: 'pointer' }}
            />
          </div>
        )}
        renderOption={(props, option: any) => {
          const handleClick = () => {
            if (option.type === 'screen') {
              if (option.path?.startsWith('http')) {
                window.open(option.path, '_blank', 'noopener,noreferrer');
              } else {
                history.push(option.path);
              }
            } else if (option.type === 'acao') {
              history.push(`/analysis/${option.name}`);
            } else if (option.type === 'fii') {
              history.push(`/analysis/${option.name}`);
            } else if (option.type === 'video') {
              history.push(`/watch/?v=${option.video_id}`);
            }
          };

          return (
            <li {...props} onClick={handleClick}>
              <ContainerOptionSearch className="searchOptionContainer">
                {/* Ícone/Imagem de acordo com o tipo */}
                {option.type === 'screen' ? (
                  <Desktop
                    size="1.8rem"
                    weight="fill"
                    color="#3a576bff"
                    style={{ marginRight: 10, width: 40, height: 40 }}
                  />
                ) : option.type === 'acao' && option.image ? (
                  <img
                    src={option.image}
                    alt={option.name}
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: '4px',
                      marginRight: 10,
                      objectFit: 'contain',
                      background: '#fff',
                    }}
                  />
                ) : option.type === 'fii' ? (
                  <Buildings
                    size="1.8rem"
                    weight="fill"
                    color="#ff6600"
                    style={{ marginRight: 10, width: 40, height: 40 }}
                  />
                ) : option.type === 'video' ? (
                  <Video
                    size="1.8rem"
                    weight="fill"
                    color="#1C2D38"
                    style={{ marginRight: 10, width: 40, height: 40 }}
                  />
                ) : (
                  <Cube
                    size="1.8rem"
                    weight="fill"
                    color="#888"
                    style={{ marginRight: 10, width: 40, height: 40 }}
                  />
                )}

                <p className="searchOptionText">
                  <strong>{option.name}</strong>{' '}
                  {option.NomeEmpresa ? `– ${option.NomeEmpresa}` : ''}
                </p>

                {option.type && option.type !== 'screen' && (
                  <span
                    style={{
                      marginRight: '0',
                      marginLeft: '6px',
                      fontSize: 12,
                      fontWeight: 600,
                      padding: '2px 6px',
                      borderRadius: 6,
                      background:
                        option.type === 'fii'
                          ? '#ff6600'
                          : option.type === 'acao'
                          ? '#FFA600'
                          : option.type === 'video'
                          ? '#1C2D38'
                          : '#ddd',
                      color:
                        option.type === 'fii'
                          ? '#ffe4cc '
                          : option.type === 'acao'
                          ? '#ffffe6ff'
                          : option.type === 'video'
                          ? '#ffffffff'
                          : '#000',
                    }}
                  >
                    {typeLabels[option.type] || option.type.toUpperCase()}
                  </span>
                )}
              </ContainerOptionSearch>
            </li>
          );
        }}
      />
    );
  };

  const imgProfile = () => {
    let img = user.profile?.image;
    if (img) {
      if (
        !!img.match(
          'https://storage.googleapis.com/ibox6-wordpress.appspot.com/'
        )
      ) {
        return img;
      } else {
        return img;
      }
    }
  };
  const profile = imgProfile();

  function handleSetNewShowActive() {
    localStorage.setItem('isShowActive', JSON.stringify(!showActive));
    setShowActive(!showActive);
  }

  let path = window.location.pathname;
  // @ts-ignore
  path = path.split('/');
  path = path[path.length - 1];






  return (
    <>
      <Container
        titleHeader={title}
        shortSidebar={shortSidebar}
        fixed={styledHeader}
        screenWidth={window.screen.width}
        isMobile={isMobile}
        automatico={user.automatico}
        carteira={user.carteira}
        isFullScreen={path === 'wallet'}
        isBlackScreen={window.location.pathname === '/admin-painel/dashboard'}
      >
        <nav id="home" >
          <AppTour/>
          <img className="imageLogo" alt="Logo" src={imageLogo} onClick={() => history.push("/dashboard")} />
          {/* <div className="backTitle">
            {window.history.length > 2 && window.history.state !== null && (
              <button
                onClick={handleBackPage}
                title="Voltar página"
                type="button"
              >
                <img alt="voltar" src={imageVoltar} />
              </button>
            )}

            {/********************************************************************************  */}

          {/* {title !== '' && (
              <h3>
                {title === 'Página inicial'
                  ? `Boas-vindas, ${user.Name.split(' ')[0]} `
                  : title}
              </h3>
            )}
          </div> */}
          <div className="divInput">{!isMobile && renderSearchMenu()}</div>

          {/* {window.history.length > 2 && window.history.state !== null && ( */}
          {/* )} */}
          <div className="userContent">
            <>
              <div id="premium">
                {isPremium ? (
                  <button
                    className="buttonPremium active"
                    onClick={() => history.push("/profile-edit")}
                    title="Gerenciar assinatura e configurações"
                  >
                    <Crown width={20} height={20} color="#FFC354" weight="fill" />
                    Premium
                  </button>
                ) : (
                  <button
                    className="buttonPremium"
                    onClick={() => history.push("/pagamentos")}
                  >
                    <Crown width={20} height={20} color="#FFC354" weight="fill" />
                    Seja Premium
                  </button>
                )}
              </div>
              <ul>
                <div
                  id="b3"
                  title={
                    b3Connected === false
                      ? 'Conta não conectada à B3'
                      : 'Conectado à B3'
                  }
                >
                  {b3Connected !== false ? (
                    <DropdownAntd
                      overlay={menu}
                      trigger={['click']}
                      placement="bottomRight"
                    >
                      <a onClick={(e) => e.preventDefault()} className="linkB3">
                        <PlugsConnected
                          style={{ width: '24px', height: '24px' }}
                          color="#73CE61"

                        />
                        
                      </a>
                    </DropdownAntd>
                  ) : (
                    <Dropdown as="li" className="linkB3">
                      <Dropdown.Toggle
                        as="a"
                        variant=""
                        className="i-false c-pointer"
                      >
                        <Plugs
                          style={{ width: '24px', height: '24px' }}
                          color="#F94361"
                          onClick={() => setModalLinkAccountB3(true)}
                        />
                        <WarningCircle color="#F94361" />
                      </Dropdown.Toggle>
                    </Dropdown>
                  )}
                </div>
                <li
                  style={{
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {showActive ? (
                    <Eye
                      style={{ width: '24px', height: '24px' }}
                      color="#F1F2F3"
                      onClick={handleSetNewShowActive}
                      className="eye-icon"
                    />
                  ) : (
                    <EyeSlash
                      style={{ width: '34px', height: '34px' }}
                      color="#F1F2F3"
                      onClick={handleSetNewShowActive}
                      className="eye-icon2"
                    />
                  )}
                </li>

                <Notifications />
                {isMobile && (
                  <div className="contentIcons">
                    <List
                      size={isMobile ? '1.5rem' : '2rem'}
                      color="#F1F2F3"
                      onClick={() => setShowMenu(true)}
                    />
                  </div>
                )}
              </ul>
            </>

            {!isMobile && (
              <ContentUser
                onClick={() => history.push('/recommended-posts')}
                title={title}
              >
                {window.screen.width > 480 && <h4>{user.Name}</h4>}
                <div className="avatar-container">
                  <img
                    src={
                      user
                        ? user?.profile?.image
                          ? `${profile}`
                          : userdefault
                        : userdefault
                    }
                  />

                  {/* ADM (is_superuser = true) */}
                  {user?.is_staff === true && (
                    <GearSix className="badge-icon admin" />
                  )}

                  {/* Premium (assinatura ativa) */}
                  {plan?.NomePlano &&
                    ['premium'].includes(plan.NomePlano.toLowerCase()) && (
                      <Crown
                        color="#FFC354"
                        weight="fill"
                        className="badge-icon premium"
                      />
                    )}
                </div>
              </ContentUser>
            )}
          </div>
        </nav>
      </Container>

      <ContainerShowMenu show={showMenu}>
        <div className="red" />
        <div className="blue" />
        <HeaderMenu setShowMenu={setShowMenu}>{renderSearchMenu()}</HeaderMenu>
      </ContainerShowMenu>

      <ModalDesigner
        id="linkModal"
        isOpen={modalLinkAccountB3}
        setState={setModalLinkAccountB3}
        title="Vincular conta B3"
        size="sm"
      >
        <LinkAccountB3 onCloseModal={setModalLinkAccountB3} />
      </ModalDesigner>
    </>
  );
}
